
import { AlphaLoader } from "@/components/ui/alpha-loader";

const GprofileLoading = () => {
  console.log('⏳ Showing loading state');
  
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <AlphaLoader 
        size="large" 
        className="text-center"
      />
    </div>
  );
};

export default GprofileLoading;
